<template>
  <div class="card">
    <b-form-group label="Day of the week:" v-slot="{ ariaDescribedby }">
      <b-form-checkbox-group
        id="checkbox-group-1"
        v-model="selected"
        :options="options"
        :aria-describedby="ariaDescribedby"
        name="flavour-1"
      ></b-form-checkbox-group>
    </b-form-group>
    <b-form-timepicker
      placeholder="Choose a time"
      id="timepicker"
      size="sm"
      locale="en"
      class="mb-2"
      v-model="time"
    ></b-form-timepicker>
  </div>
</template>

<script>
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

export default {
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      cronExpression: "",
      time: "16:00:00",
      selected: [],
      options: [
        { text: "Sun", value: "0" },
        { text: "Mon", value: "1" },
        { text: "Tue", value: "2" },
        { text: "Wed", value: "3" },
        { text: "Thu", value: "4" },
        { text: "Fri", value: "5" },
        { text: "Sat", value: "6" }
      ],
      weeks: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]
    };
  },
  created() {
    this.calcCron();
  },
  methods: {
    getCronExpression() {
      const weeksNumbers = this.selected;
      const timeArray = this.time.split(":");
      const selectedWeeks = [];
      for (const week of weeksNumbers) {
        const weekNew = parseInt(week);
        selectedWeeks.push(this.weeks[weekNew]);
      }
      const days = selectedWeeks.join(",");
      this.cronExpression = `${timeArray[1]} ${timeArray[0]} ? * ${days} *`;
    },
    calcCron() {
      if (!this.value) return;

      // Strip "cron(...)" wrapper if present
      let raw = this.value.trim();
      if (raw.startsWith("cron(") && raw.endsWith(")")) {
        raw = raw.slice(5, -1);
      }

      const timeArray = raw.split(" ");
      if (timeArray.length !== 6) return;

      const minute = timeArray[0].padStart(2, "0");
      const hour = timeArray[1].padStart(2, "0");
      this.time = `${hour}:${minute}:00`;

      const dayField = timeArray[4];
      let selectedWeeks;

      if (!dayField || dayField === "?" || dayField === "*") {
        selectedWeeks = [];
      } else if (dayField.includes("-")) {
        const parts = dayField.split("-");
        const rangeWeeks = parts.map(item => this.getWeekNumber(item));
        selectedWeeks = this.getWeeks(rangeWeeks[0], rangeWeeks[1]);
      } else if (dayField.includes(",")) {
        selectedWeeks = dayField.split(",").map(item => this.getWeekNumber(item));
      } else {
        selectedWeeks = [this.getWeekNumber(dayField)];
      }

      if (selectedWeeks) {
        this.selected = selectedWeeks;
      }
    },
    getWeeks(weekBegin, weekEnd) {
      const weeks = [];
      for (let index = weekBegin; index <= weekEnd; index++) {
        weeks.push(index);
      }
      return weeks;
    },
    getWeekNumber(week) {
      const trimmed = week.trim();
      // Handle numeric values directly
      if (!isNaN(trimmed)) {
        return String(parseInt(trimmed) % 7); // normalize to 0-6
      }
      const found = this.options.find(t => t.text.toLowerCase() === trimmed.toLowerCase());
      return found ? found.value : null;
    }
  },
  watch: {
    time() {
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    selected() {
      this.getCronExpression();
      this.$emit("input", this.cronExpression);
    },
    value() {
      this.calcCron();
    }
  }
};
</script>

<style lang="scss" scoped></style>
